import { getUserInfo } from '@/api/userCenter'
import { setToken, getToken, removeToken } from '@/utils/auth'
import { setCache, getCache, removeCache } from '@/utils/cache'
import { userLogin } from '@/api/user'

// 用户信息存储模块
const getDefaultState = () => {
	return {
		userInfo: {},
		userId: getCache('cjt_user_id'),
		realName: '',
		phone: '',
		roles: [],
		token: getToken(),
		userUnreadMessageCount: 0, // 用户未读消息数量
		unreadWarning: 0
	}
}

const state = getDefaultState()

const mutations = {
	SET_USERINFO: (state, userInfo) => {
		state.userInfo = userInfo
	},
	SET_REALNAME: (state, realName) => {
		state.realName = realName
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
	},
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_USER_ID: (state, userId) => {
		state.userId = userId
	},
	SET_PHONE: (state, phone) => {
		state.phone = phone
	},
	SET_UNREAD_MESSAGE_COUNT: (state, count) => {
		state.userUnreadMessageCount = count
	},
	SET_UNREAD_WARNING: (state, count) => {
		state.unreadWarning = count
	}
}
const actions = {
	setUserInfo({ commit }, userInfo) {
		commit('SET_USERINFO', userInfo)
	},
	setRoles({ commit }, roles) {
		commit('SET_ROLES', roles)
	},
	setToken({ commit }, token) {
		commit('SET_TOKEN', token)
	},
	resetState({ commit }) {
		commit('SET_USERINFO', {})
		commit('SET_ROLES', [])
		commit('SET_TOKEN', '')
	},
	setUnreadMessageCount({ commit }, count) {
		commit('SET_UNREAD_MESSAGE_COUNT', count)
	},
	setUnreadWarning({ commit }, count) {
		commit('SET_UNREAD_WARNING', count)
	},
	// 用户登录
	login({ commit }, userInfo) {
		return new Promise((resolve, reject) => {
			userLogin(userInfo)
				.then(response => {
					const { data } = response
					commit('SET_TOKEN', data.token)
					commit('SET_USER_ID', data.userId)
					setToken(data.token)
					setCache('cjt_user_id', data.userId)
					resolve()
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	//  获取用户信息
	getUserInfo({ commit, state, dispatch }) {
		return new Promise((resolve, reject) => {
			getUserInfo()
				.then(async response => {
					const { data } = response
					commit('SET_REALNAME', data.realName)
					commit('SET_PHONE', data.phone)
					commit('SET_USERINFO', data)
					commit('enterprise/SET_COMPANY_ID', data.companyId, { root: true })
					await dispatch('enterprise/setCompany', data.companyId, { root: true })
					await dispatch('enterprise/setCompanyAdmin', data.enterpriseAdmin, { root: true })
					if (data.memberRecordList.length > 0) {
						// 从权益列表中取出会员等级
						const memberGrade = data.memberRecordList[0].memberGrade
						await dispatch('vip/setVipLevel', memberGrade, { root: true })
					}
					resolve()
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	// 退出登录
	logout({ commit, state }) {
		return new Promise((resolve, reject) => {
			removeToken() // must remove  token  first
			removeCache('cjt_user_id')
			resolve()
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
